import {useEffect} from 'react';
import {useQuery} from '@tanstack/react-query';
import contentSubmissionsApi from '@/api/contentSubmissions';
import {ContentSubmission} from '@/views/gig-deliverables/types';
import {useProcessingPreviewStore} from '@/views/gig-deliverables/processingPreviewStore';

const PROCESSING_POLL_INTERVAL_MS = 3000;

export function gigSubmissionsQueryKey(gigId: string) {
  return ['gig-submissions', gigId];
}

export default function useGigSubmissionsQuery(gigId: string) {
  const previews = useProcessingPreviewStore((state) => state.bySubmissionId);
  const forgetAvailable = useProcessingPreviewStore(
    (state) => state.forgetAvailable
  );
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: gigSubmissionsQueryKey(gigId),
    queryFn: () => contentSubmissionsApi.list(gigId),
    enabled: Boolean(gigId),
    refetchOnWindowFocus: false,
    refetchInterval: (response) =>
      response?.data.some((submission) => submission.aasmState === 'processing')
        ? PROCESSING_POLL_INTERVAL_MS
        : false,
  });
  useEffect(() => {
    const availableIds = (data?.data ?? [])
      .filter((submission) => submission.thumbnailUrl)
      .map((submission) => submission.id);
    forgetAvailable(availableIds);
  }, [data, previews, forgetAvailable]);

  return {
    submissions: (data?.data ?? []) as ContentSubmission[],
    isLoading,
    isError,
    error,
    refetch,
  };
}
